import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const deleteUser = async (module, { userID, opts = {} }) => {
  const { rootGetters, dispatch } = module;
  const api = useApiStore();
  const config = Object.assign(getDefaultOpts(), opts);
  dispatch(
    "setSettingsVar",
    {
      key: "loading",
      value: true,
    },
    { root: true }
  );

  await dispatch("httpRequest", {
    func: api.deleteUser(userID),
    config,
  });

  const users = { ...rootGetters.getSettingsVar("users") };
  delete users[userID];

  dispatch(
    "setSettingsVar",
    {
      key: "users",
      value: users,
    },
    { root: true }
  );
  dispatch(
    "setSettingsVar",
    {
      key: "selectedUserIndex",
      value: 0,
    },
    { root: true }
  );
  dispatch(
    "setSettingsVar",
    {
      key: "loading",
      value: false,
    },
    { root: true }
  );
};

export { deleteUser };
